<template>
  <div class="ic-form__address">
    <fieldset>
    <legend><h3>Adres korespondencyjny</h3></legend>

    <div class="row">
      <div class="col-md-8">
        <IcFormRowWrapper
          rowElement="IcFormRow"
          id="street"
          name="address.street"
          :aria="$t('aria_required')"
          :label="$t('label_street')"
          :labelWidth="4"
          :controlWidth="8"
        >
          <template slot-scope="{validator}">
            <IcInput id="street" autocomplete="address-line1" v-model="data.street" @input="emitInput(data,validator)" maxlength="50" capitalize="1"></IcInput>
          </template>
        </IcFormRowWrapper>
      </div>
      <div class="col-md-2 form-padding-left">
        <IcFormRowWrapper
          rowElement="IcFormRow"
          id="streetNo"
          name="address.streetNo"
          :aria="$t('aria_required')"
          :label="$t('label_streetNo')"
          :labelWidth="4"
          :controlWidth="8"
        >
          <template slot-scope="{validator}">
            <IcInput id="streetNo" autocomplete="address-line2" v-model="data.streetNo" @input="emitInput(data,validator)" maxlength="10"></IcInput>
          </template>
        </IcFormRowWrapper>
      </div>
      <div class="col-md-2 form-padding-left">
        <IcFormRowWrapper
          rowElement="IcFormRow"
          id="apartment"
          name="address.apartment"
          :aria="$t('aria_required')"
          :label="$t('label_apartment')"
          :labelWidth="4"
          :controlWidth="8"
        >
          <template slot-scope="{validator}">
            <IcInput id="apartment" autocomplete="address-line3" v-model="data.apartment" @input="emitInput(data,validator) " maxlength="10"></IcInput>
          </template>
        </IcFormRowWrapper>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <IcFormRowWrapper
          rowElement="IcFormRow"
          id="zip"
          name="address.zip"
          :aria="$t('aria_required')"
          :label="$t('label_zip')"
          :labelWidth="4"
          :controlWidth="2"
        >
          <template slot-scope="{validator}">
            <IcInputZip id="zip" autocomplete="postal-code" v-model="data.zip" @input="emitInput(data,validator)" maxlength="30"></IcInputZip>
          </template>
        </IcFormRowWrapper>
      </div>
      <div class="col-md-9 form-padding-left">
        <IcFormRowWrapper
          rowElement="IcFormRow"
          id="city"
          name="address.city"
          :aria="$t('aria_required')"
          :label="$t('label_city')"
          :labelWidth="4"
          :controlWidth="8"
        >
          <template slot-scope="{validator}">
            <IcInput id="city" v-model="data.city" autocomplete="address-level2" @input="emitInput(data,validator)" maxlength="30" capitalize="1"></IcInput>
          </template>
        </IcFormRowWrapper>
      </div>
    </div>
  </fieldset>
  </div>
</template>

<script>
import IcInput from "@/components/ic-common/form/controls/Input";
import IcInputZip from "@/components/ic-common/form/controls/InputZip";
import { Address } from "@/components/ic/form/contact/Model/Address";
import { emitInput } from "./mixins";

export default {
  name: "IcFormContactAddress",
  props: {
    value: {
      type: [Object],
      default: new Address()
    }
  },
  watch: {
    value: function(newValue, oldValue) {
      this.data = this.value;
    }
  },
  data() {
    return {
      data: Object.assign({}, new Address(), this.value)
    };
  },
  methods: {
    emitInput
  },
  components: {
    IcInput,
    IcInputZip
  }
};
</script>

<style>
</style>
